import React, { useEffect, useState } from "react";
import { getData } from "../../axios/axiosHelper";
import toast from "react-hot-toast";

const DashbooardHooks = () => {
  const [dashboardData, setDashboardData] = useState({});
  const [loading, setLoading] = useState(false);

  const getDashboardData = async () => {
    setLoading(true);
    getData("/dashboard", true)
      .then((response) => {
        setDashboardData(response.data?.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getDashboardData();
  }, []);

  const userTypeData = {
    title: "Account Types",
    labels: ["Customers", "Merchants"],
    chartData: [
      dashboardData?.clientsCount?.users,
      dashboardData?.clientsCount?.sellers,
    ],
  };

  const admistritorfeeData = {
    title: "Admistritor Fees",
    labels: ["Collected Amount", "Total Administrative Fees"],
    chartData: [
      dashboardData?.administrativeFees?.collectedAdministrativeFees,
      dashboardData?.administrativeFees?.totalAdministrativeFees,
    ],
  };

  return {
    userTypeData,
    admistritorfeeData,
    dashboardData,
    loading,
  };
};

export default DashbooardHooks;
